import { IReportProducts } from 'partner360/features/reports/model/types'
import { ICompletenessReportCompleteness } from 'partner360/models/report/completenessReport/ICompletenessReportCompleteness'
import { IReportPartner } from 'partner360/models/report/IReportPartner'
import { ISobAnalyticsReportInfo } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportInfo'
import { ISobSubmittingReportInfo } from 'partner360/models/report/sobSubmittingReport/ISobSubmittingReportInfo'

type TDependentValues<T> = Partial<Record<keyof T, string[] | string>>

export const getUniqueValues = <
  T extends keyof U,
  U extends
    | ICompletenessReportCompleteness
    | IReportPartner
    | ISobSubmittingReportInfo
    | IReportProducts
    | ISobAnalyticsReportInfo,
>(
  data: U[],
  key: T,
  dependentValues: TDependentValues<U> = {}
): U[] => {
  const uniqueValues = new Map<string, U>()

  data.forEach((item) => {
    const matchesDependencies = Object.entries(dependentValues).every(([depKey, depValue]) => {
      const itemValue = item[depKey as keyof U]
      if (Array.isArray(depValue)) {
        return depValue.includes(itemValue as string)
      }
      return itemValue === depValue
    })

    if (matchesDependencies) {
      const value = item[key]
      if (value !== null && value !== undefined) {
        uniqueValues.set(value as string, item)
      }
    }
  })

  return Array.from(uniqueValues.values())
}
